import {
    ANNOTATION_VIDEO_DISPLAY,
    ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    ANNOTATION_LOCATION,
    VIDEO_SRC_TYPE
} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/wwf%2Fcreate-scottish-canvas%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "left";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "WORKS";

const PAINTING_ID_POST_FIX = "PH";

// const SPRITE_HORIZONTAL_OFFSET = -0.022;
const SPRITE_HORIZONTAL_OFFSET = -0.015;
// const SPRITE_HORIZONTAL_OFFSET_W_09 = 0.01;
// const SPRITE_VERTICAL_OFFSET = -0.02;


const AnnotationsDB = [

    /* Videos */
    {
        paintingId: 'W03V05',
        videoId: 'W03V05',
        standaloneVideoElementId: 'W03V05',
        videoURL: 'W03V05.mp4',
        // headerText: `<h5></h5>`,
        // bodyText: ``,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
        useVideoMeshButton: 'Y',
        // videoGroupButtonId: 'group_S06_01',
        // useVideoGroupMeshButton: 'Y',
        videoLoop: false,
        // annotation_location: ANNOTATION_LOCATION.CENTER_LEFT,
    },
    // {
    //     paintingId: 'W02T04E01',
    //     videoId: 'W02T04E01',
    //     standaloneVideoElementId: 'W02T04E01',
    //     videoURL: 'W02T04E01.mov',
    //     // headerText: `<h5></h5>`,
    //     // bodyText: ``,
    //     displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
    //     displayMesh: 'N',
    //     // displayHeight: 90,
    //     videoAutoPlay: 'N',
    //     videoTextureEncoding: THREE.sRGBEncoding,
    //     // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    //     useVideoMeshButton: 'Y',
    //     // videoGroupButtonId: 'group_S06_01',
    //     // useVideoGroupMeshButton: 'Y',
    //     videoLoop: false,
    //     // annotation_location: ANNOTATION_LOCATION.CENTER_LEFT,
    // },
    /* Videos */


    /* Audio */
    {
        paintingId: 'W01P02A01',
        videoId: 'W01P02A01',
        standaloneVideoElementId: 'W01P02A01',
        videoURL: 'W01P02A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W01T01A01',
        videoId: 'W01T01A01',
        standaloneVideoElementId: 'W01T01A01',
        videoURL: 'W01T01A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W02T03A01',
        videoId: 'W02T03A01',
        standaloneVideoElementId: 'W02T03A01',
        videoURL: 'W02T03A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W02T04A01',
        videoId: 'W02T04A01',
        standaloneVideoElementId: 'W02T04A01',
        videoURL: 'W02T04A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W03P07A01',
        videoId: 'W03P07A01',
        standaloneVideoElementId: 'W03P07A01',
        videoURL: 'W03P07A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W03T06A01',
        videoId: 'W03T06A01',
        standaloneVideoElementId: 'W03T06A01',
        videoURL: 'W03T06A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W05P09A01',
        videoId: 'W05P09A01',
        standaloneVideoElementId: 'W05P09A01',
        videoURL: 'W05P09A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W05P10A01',
        videoId: 'W05P10A01',
        standaloneVideoElementId: 'W05P10A01',
        videoURL: 'W05P10A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W05P11A01',
        videoId: 'W05P11A01',
        standaloneVideoElementId: 'W05P11A01',
        videoURL: 'W05P11A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W05T12A01',
        videoId: 'W05T12A01',
        standaloneVideoElementId: 'W05T12A01',
        videoURL: 'W05T12A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W06P13A01',
        videoId: 'W06P13A01',
        standaloneVideoElementId: 'W06P13A01',
        videoURL: 'W06P13A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W06P15A01',
        videoId: 'W06P15A01',
        standaloneVideoElementId: 'W06P15A01',
        videoURL: 'W06P15A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W06T14A01',
        videoId: 'W06T14A01',
        standaloneVideoElementId: 'W06T14A01',
        videoURL: 'W06T14A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W07P16A01',
        videoId: 'W07P16A01',
        standaloneVideoElementId: 'W07P16A01',
        videoURL: 'W07P16A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W07T17A01',
        videoId: 'W07T17A01',
        standaloneVideoElementId: 'W07T17A01',
        videoURL: 'W07T17A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W07P18A01',
        videoId: 'W07P18A01',
        standaloneVideoElementId: 'W07P18A01',
        videoURL: 'W07P18A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W07P20A01',
        videoId: 'W07P20A01',
        standaloneVideoElementId: 'W07P20A01',
        videoURL: 'W07P20A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W07P21A01',
        videoId: 'W07P21A01',
        standaloneVideoElementId: 'W07P21A01',
        videoURL: 'W07P21A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W07P22A01',
        videoId: 'W07P22A01',
        standaloneVideoElementId: 'W07P22A01',
        videoURL: 'W07P22A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W07T19A01',
        videoId: 'W07T19A01',
        standaloneVideoElementId: 'W07T19A01',
        videoURL: 'W07T19A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W08P23A01',
        videoId: 'W08P23A01',
        standaloneVideoElementId: 'W08P23A01',
        videoURL: 'W08P23A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W08P24A01',
        videoId: 'W08P24A01',
        standaloneVideoElementId: 'W08P24A01',
        videoURL: 'W08P24A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09P25A01',
        videoId: 'W09P25A01',
        standaloneVideoElementId: 'W09P25A01',
        videoURL: 'W09P25A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09P26A01',
        videoId: 'W09P26A01',
        standaloneVideoElementId: 'W09P26A01',
        videoURL: 'W09P26A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09P27A01',
        videoId: 'W09P27A01',
        standaloneVideoElementId: 'W09P27A01',
        videoURL: 'W09P27A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09P29A01',
        videoId: 'W09P29A01',
        standaloneVideoElementId: 'W09P29A01',
        videoURL: 'W09P29A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09P31A01',
        videoId: 'W09P31A01',
        standaloneVideoElementId: 'W09P31A01',
        videoURL: 'W09P31A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09P32A01',
        videoId: 'W09P32A01',
        standaloneVideoElementId: 'W09P32A01',
        videoURL: 'W09P32A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09T28A01',
        videoId: 'W09T28A01',
        standaloneVideoElementId: 'W09T28A01',
        videoURL: 'W09T28A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W09T28A02',
        videoId: 'W09T28A02',
        standaloneVideoElementId: 'W09T28A02',
        videoURL: 'W09T28A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W10P33A01',
        videoId: 'W10P33A01',
        standaloneVideoElementId: 'W10P33A01',
        videoURL: 'W10P33A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W10P34A01',
        videoId: 'W10P34A01',
        standaloneVideoElementId: 'W10P34A01',
        videoURL: 'W10P34A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11P35A01',
        videoId: 'W11P35A01',
        standaloneVideoElementId: 'W11P35A01',
        videoURL: 'W11P35A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11P36A01',
        videoId: 'W11P36A01',
        standaloneVideoElementId: 'W11P36A01',
        videoURL: 'W11P36A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11P38A01',
        videoId: 'W11P38A01',
        standaloneVideoElementId: 'W11P38A01',
        videoURL: 'W11P38A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11P39A01',
        videoId: 'W11P39A01',
        standaloneVideoElementId: 'W11P39A01',
        videoURL: 'W11P39A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11P41A01',
        videoId: 'W11P41A01',
        standaloneVideoElementId: 'W11P41A01',
        videoURL: 'W11P41A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11P42A01',
        videoId: 'W11P42A01',
        standaloneVideoElementId: 'W11P42A01',
        videoURL: 'W11P42A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11T37A01',
        videoId: 'W11T37A01',
        standaloneVideoElementId: 'W11T37A01',
        videoURL: 'W11T37A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11T37A02',
        videoId: 'W11T37A02',
        standaloneVideoElementId: 'W11T37A02',
        videoURL: 'W11T37A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W11T40A01',
        videoId: 'W11T40A01',
        standaloneVideoElementId: 'W11T40A01',
        videoURL: 'W11T40A01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W12P43A01',
        videoId: 'W12P43A01',
        standaloneVideoElementId: 'W12P43A01',
        videoURL: 'W12P43A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W12T44A01',
        videoId: 'W12T44A01',
        standaloneVideoElementId: 'W12T44A01',
        videoURL: 'W12T44A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W12T44A02',
        videoId: 'W12T44A02',
        standaloneVideoElementId: 'W12T44A02',
        videoURL: 'W12T44A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13P47A01',
        videoId: 'W13P47A01',
        standaloneVideoElementId: 'W13P47A01',
        videoURL: 'W13P47A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13T45A01',
        videoId: 'W13T45A01',
        standaloneVideoElementId: 'W13T45A01',
        videoURL: 'W13T45A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13T45A02',
        videoId: 'W13T45A02',
        standaloneVideoElementId: 'W13T45A02',
        videoURL: 'W13T45A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13T46A01',
        videoId: 'W13T46A01',
        standaloneVideoElementId: 'W13T46A01',
        videoURL: 'W13T46A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13T46A02',
        videoId: 'W13T46A02',
        standaloneVideoElementId: 'W13T46A02',
        videoURL: 'W13T46A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13T48A01',
        videoId: 'W13T48A01',
        standaloneVideoElementId: 'W13T48A01',
        videoURL: 'W13T48A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13T49A01',
        videoId: 'W13T49A01',
        standaloneVideoElementId: 'W13T49A01',
        videoURL: 'W13T49A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W13T49A02',
        videoId: 'W13T49A02',
        standaloneVideoElementId: 'W13T49A02',
        videoURL: 'W13T49A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T50A01',
        videoId: 'W14T50A01',
        standaloneVideoElementId: 'W14T50A01',
        videoURL: 'W14T50A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T50A02',
        videoId: 'W14T50A02',
        standaloneVideoElementId: 'W14T50A02',
        videoURL: 'W14T50A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T51A01',
        videoId: 'W14T51A01',
        standaloneVideoElementId: 'W14T51A01',
        videoURL: 'W14T51A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T51A02',
        videoId: 'W14T51A02',
        standaloneVideoElementId: 'W14T51A02',
        videoURL: 'W14T51A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T52A01',
        videoId: 'W14T52A01',
        standaloneVideoElementId: 'W14T52A01',
        videoURL: 'W14T52A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T53A01',
        videoId: 'W14T53A01',
        standaloneVideoElementId: 'W14T53A01',
        videoURL: 'W14T53A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T53A02',
        videoId: 'W14T53A02',
        standaloneVideoElementId: 'W14T53A02',
        videoURL: 'W14T53A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T54A01',
        videoId: 'W14T54A01',
        standaloneVideoElementId: 'W14T54A01',
        videoURL: 'W14T54A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T54A02',
        videoId: 'W14T54A02',
        standaloneVideoElementId: 'W14T54A02',
        videoURL: 'W14T54A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T55A01',
        videoId: 'W14T55A01',
        standaloneVideoElementId: 'W14T55A01',
        videoURL: 'W14T55A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    {
        paintingId: 'W14T55A02',
        videoId: 'W14T55A02',
        standaloneVideoElementId: 'W14T55A02',
        videoURL: 'W14T55A02.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        useVideoMeshButton:'Y',
    },
    /* Audio */

/* Image and Wall Text */
    /* Wall 01 */
    {
        paintingId:  `W01T01${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>The Great Scottish Canvas</h5>`,
        bodyText: `In this vital year for climate and nature, the Great Scottish Canvas showcases your visions for a future where we tackle the climate and nature crises and create a greener, fairer Scotland for all.<br><br>We have brought together voices from the four corners of the country- from Shetland to the Borders, Aberdeen to the Western Isles, in Punjabi, Gaelic, Scots and English. On the map to the right, you can see where in Scotland the art and poetry in our gallery has come from. <br><br>We’re proud to include the thought-provoking  words from renowned Scottish writers Jackie Kay and Alexander McCall Smith. ‘Only One Home’ is an exclusive poem by Alexander McCall Smith about the climate and nature emergencies.  ‘Wildlife’ was written by Jackie Kay in 1974 when she was 12 years old.  In it she describes her concerns about the future of the natural world, and the need for urgent action.<br><br>Moving through our gallery you will see first the inspiring messages from today’s young generation, before you enter the main gallery full of the words of poets and writers from across Scotland, then go onto to explore paintings, textile, sculpture and digital art from talented artists, which in different ways, illustrate the future we hope to see for ourselves, our nature and climate.<br><br>Our hope is that the artwork and poetry that you see today will inspire conversations about the Scotland you want to see tomorrow.<br><br><i>The  exhibition is curated with the support of the National Galleries of Scotland.<br>Audio recordings by voiceover artist Toni Frutin</i>`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
        // annotation_location_vert_offset: SPRITE_VERTICAL_OFFSET,
        // annotation_location: ANNOTATION_LOCATION.CENTER,
    },
    {
        paintingId:  `W01P02${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W01P02.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>The Great Scottish Canvas Map</h5>`,
        bodyText: `We have brought together voices from the four corners of the country- from Shetland to the Borders, Aberdeen to the Western Isles, in Punjabi, Gaelic, Scots and English. On this map, you can see where in Scotland the art and poetry in our gallery has come from.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 01 */

    /* Wall 02 */
    {
        paintingId:  `W02T03${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P56.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Alexander McCall Smith</h5>`,
        bodyText: `Scottish writer Alexander McCall Smith, best known for his <i>The No.1 Ladies Detective Agency books</i>, has joined forces with us to publish a beautiful new poem about the climate and nature crises.<br><br>We’re thrilled Alexander McCall Smith has shared this moving, new poem, which we are sure have inspired others to write their own creative poems, drawings and artworks about Scotland’s nature and its future, and the actions they want to see happen to protect our one shared home.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W02T04${PAINTING_ID_POST_FIX}`,
        videoId: 'W02T04E01',
        // videoId: `W02T04E01${PAINTING_ID_POST_FIX}`,
        standaloneVideoElementId: 'W02T04E01',
        videoURL: 'W02T04E01.mov',
        headerText: `<h5>Only One Home</h5>`,
        bodyText: `<b>Alexander McCall Smith reading his poem 'Only One Home'.</b><br><br>It's always useful, we're told,<br>To ensure a spare is ready to hand:<br>About the house an extra pair<br>Of spectacles may come in useful,<br>A front door key, or two perhaps,<br>Concealed for emergency use;<br>These things are simply prudent, signs<br>Of a cautious mentality, of planning ahead<br>For the unexpected, the contingency<br>We never thought would come about;<br>And yet there are some important things,<br>Of which we may possess only one:<br>Each of us has only one heart, one life,<br>One memory in which to lodge the remembrance<br>Of the things we know and love;<br>These are private and individual limitations;<br>Singularity applies, though, just as much<br>To that which belong to all:<br>We have only one home, one planet,<br>One earth on which each of us may sit down<br>And speak of and treat as our own:<br>Only one, irreplaceable, unduplicated<br>By a spare earth somewhere else;<br>Just this one, this one we love.<br>And that, perhaps, is what we might<br>Tell ourselves as we look upon it<br>With a lover's eyes, this precious place,<br>Source of all meaning to us,<br>Site of all that we've ever known.<br>Ever felt, or ever dreamed about,<br>This spinning place, green and blue.<br>Shrouded at times by cloud, made golden<br>By sunsets that make us want to cry;<br>This is the only one we have;<br>This is the one that we must cherish,<br>Distinctive in the light of our individual moods<br>And different ways of looking at things,<br>Yet equally dear, equally nourishing,<br>Equally in need of our stewardship<br>Now, as never before; our only home.`,
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
        useVideoMeshButton: 'Y',
        // videoGroupButtonId: 'group_S06_01',
        // useVideoGroupMeshButton: 'Y',
        videoLoop: false,
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },

    /* Wall 02 */

    /* Wall 03 */
    {
        paintingId:  `W03T06${PAINTING_ID_POST_FIX}`,
        // videoId: null,
        // videoURL: null,
        videoId: 'W03V05',
        standaloneVideoElementId: 'W03V05',
        videoURL: 'W03V05.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        // isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Jackie Kay</h5>`,
        bodyText: `Award-winning writer and former Scottish Makar, Jackie Kay wrote the book entitled <i>‘Wildlife’</i> in 1974 when she was 12 years old.  It was the first piece of writing she received an award for, the World Wildlife BTA.  In it, she described her concerns about the future of the natural world, and the need for urgent action.<br><br>We are so grateful to Ms Kay for contributing her childhood writing, which resonates as much today as it did nearly 50 years ago.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W03P07${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}W03P07.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W03P07E01.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W03P07E02.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W03P07E04.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W03P07E05.jpg/info.json`],
        headerText: `<h5>Wildlife</h5>`,
        // bodyText: `<b>Pages from Jackie Kay's book 'Wildlife' from 1974.</b><br><br><i>Copyright © Jackie Kay, 1974<br>Used with permission of The Wylie Agency (UK) Limited</i>`,
        bodyText: `<b>Pages from Jackie Kay's book 'Wildlife' from 1974.</b><br><br><i>Copyright © Jackie Kay, 1974<br>Used with permission of The Wylie Agency (UK) Limited</i><br><br>Use the arrows to take a closer look at the different pages.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    // {
    //     paintingId:  `${PAINTING_ID_POST_FIX}`,
    //     videoId: null,
    //     videoURL: null,
    //     // isMediaUsed: 'N',
    //     // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: ``,
    // },
    /* Wall 03 */

    /* Wall 04 */
    /* Wall 04 */

    /* Wall 05 */
    {
        paintingId:  `W05P09${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05P09.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Bird</h5>`,
        bodyText: `Coco’s class at St Mary’s School in Melrose have painted striking, colourful birds to represent the future of our nation. This is one of the beautiful paintings created by the pupils.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W05P10${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05P10.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Scotland's future</h5>`,
        bodyText: `St Mary’s School in Melrose took inspiration from the work of environmental artist Friedensreich Hundertwasser when designing their own artworks.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W05P11${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05P11.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Scotland's future</h5>`,
        bodyText: `Amelia’s class studied artists working on environmental themes, and used this as inspiration for their own visions of a future Scotland that protects nature and fights climate.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W05T12${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05T12E01.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Oor wee Hame</h5>`,
        bodyText: `<b>Above, handwritten version of <i>'Oor wee Hame'</i></b><br><br>Scotland.<br>Where we feel at home.<br><br>Where the friendliness of Glaswegian people makes you smile, or where the beauty of Edinburgh takes your breath away.<br>Where animals roam freely in fields of islands that give you solace. Where the buttery taste of shortbread crumbles in your mouth.<br>Where towering mountains stand tall and still and the dark lochs’ waves ripple into rocky or sandy beaches.<br>Where you catch the ferry at Largs to cycle around Millport.<br>Where the fairy trails at Luss makes you believe in real magic.<br>Where The Kelpies protect you and keep you safe.<br>Where the freshest of strawberries taste sweeter than sugar.<br><br>But if we don’t take action and fix<br>our climate it will crumble into ruins<br>and oor wee hame, will be hame no more...`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 05 */

    /* Wall 06 */
    {
        paintingId:  `W06P13${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P13.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>The future our family wants</h5>`,
        bodyText: `Our piece was created during Earth Hour 2021. We sat and worked on the canvas together in candlelight. Our piece is everything we hope our world to be. People making changes to protect the environment.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W06T14${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06T14E01.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Climate Change poem</h5>`,
        bodyText: `<b>Above, handwritten version of <i>'Climate Change poem'</i></b><br><br>Global warming affects us all<br>It is putting holes in our great big wall<br>This is called the ozone layer<br>Climate change is giving us a big hot stare<br><br>Everyone has to do their part<br>Electric cars is a good start<br>The ozone layer is getting thinner<br>We don’t want no plastic in our dinner<br><br>To save the planet from global warming<br>This is our final warning<br>It is not too late to slash our emissions<br>Protecting all species and saving millions`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W06P15${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P15.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Polar Bear</h5>`,
        bodyText: `The Arctic is warming about twice as fast as the global average, causing the ice that polar bears depend on to melt away.<br><br>Loss of sea ice also threatens the bear’s main prey, seals, which need the ice to raise their young.<br><br>We can help by using our cars less and walking more, turning off electric devices when you aren’t using them, don’t let food go to waste because it uses energy to ship, preserve, refrigerate etc.<br><br>Finally, DON’T LITTER! Polar bears have died from eating plastic!<br>You never know where the wind could take you. One wee piece of rubbish, or how much it could affect someone somewhere! Think about the consequences!`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 06 */

    /* Wall 07 */
    {
        paintingId:  `W07P16${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P16.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Our wee Scotland</h5>`,
        bodyText: `Scotland is our country<br>It is a treat<br>We want to keep it neat<br>It is a place to meet.<br><br>To climb the hills<br>And look out of your windowsills<br>There may be a chill<br>But don't head for the treadmill.<br><br>This is right<br>There is no rubbish in sight<br>As you’re at the hills you can see the aurora light<br>It is pleasure at night.<br><br>When you feel the cold air on my skin<br>When I’m with my kin<br>We then wish<br>To keep our country bliss.<br><br><b>About the picture and poem</b><br><br>This picture and poem show how I would like to see our Scotland in the future – still beautiful and with no rubbish or pollution. I would like to see animals such as porpoises, Highland cows, stags and capercaillie roaming free in our wee Scotland.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W07T17${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P16.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Our wee Scotland</h5>`,
        bodyText: `Scotland is our country<br>It is a treat<br>We want to keep it neat<br>It is a place to meet.<br><br>To climb the hills<br>And look out of your windowsills<br>There may be a chill<br>But don't head for the treadmill.<br><br>This is right<br>There is no rubbish in sight<br>As you’re at the hills you can see the aurora light<br>It is pleasure at night.<br><br>When you feel the cold air on my skin<br>When I’m with my kin<br>We then wish<br>To keep our country bliss.<br><br><b>About the picture and poem</b><br><br>This picture and poem show how I would like to see our Scotland in the future – still beautiful and with no rubbish or pollution. I would like to see animals such as porpoises, Highland cows, stags and capercaillie roaming free in our wee Scotland.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W07P18${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P18.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Climate change & Scotland's future</h5>`,
        bodyText: `Auchinraich’s Primary 3 class has spent time learning about climate change and used this knowledge when creating their artworks. Phera’s vision of a future Scotland shows animals and homes and windfarms all in harmony together.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W07T19${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07T19E01.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>A Bonnie Scotland</h5>`,
        bodyText: `Scotland should be a place that is green and fair<br>All animals safe and wanting to live there<br>The skies will be blue and clear<br>Kids out playing in clean fresh air<br>No litter anywhere, sitting in bins where it belongs<br>The rivers run clear, birds splash in fresh water singing their songs<br><br>Children going to school with a full tummy<br>No hunger or poverty, everyone eating food that is yummy<br>The fine soil and water grows the best food<br>Everyone thriving in a country so good<br>Kids walk and scoot to school, choosing a healthier way<br>Less cars on the road, keeping pollution at bay<br><br>A better and happier life<br>With less stress, trouble and strife<br>Our great country leading the way<br>Showing how to care for each other and our precious land each day<br>A Scotland so bonnie and fair<br><br>I’ll always want to live there`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W07P20${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P20.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Just doing a little something</h5>`,
        bodyText: `Just doing a little something<br>Can lead to something big<br>Can lead to something huge<br>Can lead to something enormous<br>or even something gigantic<br>as small as a window box<br>as big as a raised bed<br>as huge as rockery<br>as enormous as a garden<br>as gigantic as a field<br>fill the world with plants, shrubs,<br>fruit, and vegetables.<br>Insects, bees and butterflies.<br>Love nature<br>Love the world`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W07P21${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P21.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Vision of the future</h5>`,
        bodyText: `I live on a small Island in Stronsay, Orkney, where I am surrounded by clear blue seas and green farmland with lots of nature. I feel very lucky to do so and wish everyone could enjoy what I do with no worries about the future of nature. My vision of Scotland’s future was made with collage on canvas using various media and showing the sea, sand, shells, local farming & green mountains & insects.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W07P22${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P22.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Bird</h5>`,
        bodyText: `I live on Stronsay, Orkney, a small island with lots of birds and wildlife. I want everyone to look after the birds so that we have more healthy wildlife for everyone to enjoy for Scotland’s future. My artwork is a golden eagle flying between the cliffs of Hoy, where a pair have recently nested for the first time in many years.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 07 */

    /* Wall 08 */
    {
        paintingId:  `W08P23${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P23.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Eco Bus</h5>`,
        bodyText: `This entry was created by my mum and I together and named <i>“Eco Bus”</i>. We envisage a future with more sustainable and affordable public transport options and one where we are no longer using polluting modes of transport. We have represented these thoughts with our “Eco Bus” made with plants from our garden, featuring happy plant-people in the bus windows.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W08P24${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}W08P24.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}W08P24E01.jpg/info.json`],
        headerText: `<h5>Green Space</h5><h6>Don't let our planet fade!</h6>`,
        // bodyText: `This photo was taken on a walk to Drumpellier Lochs at Coatbridge with my 4b class in May 2021. Is it a wonderful country park close to the school with access for all and I love the green space, clean air and being able to spend time in nature. It is my wish for future pupils to continue to enjoy nice places in nature therefore it is essential we look after our planet!`,
        bodyText: `This photo was taken on a walk to Drumpellier Lochs at Coatbridge with my 4b class in May 2021. Is it a wonderful country park close to the school with access for all and I love the green space, clean air and being able to spend time in nature. It is my wish for future pupils to continue to enjoy nice places in nature; therefore it is essential we look after our planet!`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 08 */

    /* Wall 09 */
    {
        paintingId:  `W09P25${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}W09P25.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}W09P25E01.jpg/info.json`],
        headerText: `<h5>Nature & Nurture in Balance</h5>`,
        bodyText: `My wall-hanging is designed to show agriculture existing in harmony with the environment. For our continued existence, both our environment and agriculture are of the utmost importance, and during the recent lockdowns this has been brought home to all of us. Our daily exercise is enhanced if we can access the countryside or other green spaces. The recent limitations on global transportation and the continuing effects of global warming are emphasising the importance of growing and producing food as close to home as possible. I created this piece during the first lockdown, and it helped me personally during that time.`,
        displayMesh: 'N',
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET_W_09,
    },
    {
        paintingId:  `W09P26${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P26.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Runes</h5>`,
        bodyText: `This woven tapestry is made from wool dyed with mushrooms found in Scotland.  In weaving <i>Runes</i>, I was thinking about times when the balance of man and nature was not so destructive. I am concerned about the sustainability of fungi and adhere to a code of practise governing the ethical harvesting and safe dye practice. Looking forward, I want Scotland to be a country which promotes biodiversity of species through managing our land using sustainable farming and forestry practices.`,
        displayMesh: 'N',
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W09P27${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P27.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Ghost Fishing</h5>`,
        bodyText: `I’m a Marine Biologist and beachcomber and I’m acutely aware of the problem of plastic and other pollution on our beaches. This piece was made to illustrate the huge hidden problem in our oceans caused by discarded fishing gear which ends up on the seabed and carries on catching and killing marine life. As it’s not as obvious as beach litter, most people are unaware of the enormity of the problem and its effect on the marine environment.`,
        displayMesh: 'N',
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W09T28${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Gifts</h5>`,
        // bodyText: `The glint of the sun on the water<br>The silvered swans the loch<br>The lap of the waves on the shoreline<br>And willows’ whispering sough<br><br>The desolate cry of the seagulls<br>Far inland from harbour or sea<br>The rippling wind through the grasses<br>And the change of light on the lea<br><br>The sudden loud hiss of the rain<br>From the umber and purple clouds<br>The air charged with hair-raising tingle<br>And the thunderclap long and loud<br><br>The dancing of ozone-charged atoms<br>Alive in the thunderous force<br>The clouds of white blossom petals<br>As the waning storm runs its course<br><br>The abacus of starlings<br>Like beads on the overhead wires<br>A loud iridescent gathering<br>A chirping and chattering choir<br><br>The glint on the aureate water<br>The lowering sun on the loch<br>The liquid gold on the shoreline<br>And the willows' whispering sough<br><br>I wrote this poem after walking in our local park, beside Carlingwark Loch in Dumfries and Galloway. At the time, I was thinking how much nature has contributed to our well-being, especially during lockdown, even if it is just the appreciation of a patch of sunlight or listening to the birds. This led me to think about how fragile our eco-system is, and how each of us can have a positive impact on it by making changes to how we live. Even small changes can make a difference.`,
        bodyText: `The glint of the sun on the water<br>The silvered swans the loch<br>The lap of the waves on the shoreline<br>And willows’ whispering sough<br><br>The desolate cry of the seagulls<br>Far inland from harbour or sea<br>The rippling wind through the grasses<br>And the change of light on the lea<br><br>The sudden loud hiss of the rain<br>From the umber and purple clouds<br>The air charged with hair-raising tingle<br>And the thunderclap long and loud<br><br>The dancing of ozone-charged atoms<br>Alive in the thunderous force<br>The clouds of white blossom petals<br>As the waning storm runs its course<br><br>The abacus of starlings<br>Like beads on the overhead wires<br>A loud iridescent gathering<br>A chirping and chattering choir<br><br>The glint on the aureate water<br>The lowering sun on the loch<br>The liquid gold on the shoreline<br>And the willows' whispering sough<br><br><b>About the poem</b><br><br>I wrote this poem after walking in our local park, beside Carlingwark Loch in Dumfries and Galloway. At the time, I was thinking how much nature has contributed to our well-being, especially during lockdown, even if it is just the appreciation of a patch of sunlight or listening to the birds. This led me to think about how fragile our eco-system is, and how each of us can have a positive impact on it by making changes to how we live. Even small changes can make a difference.`,
        displayMesh: 'N',
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W09P29${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P29.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Banff Shore</h5>`,
        bodyText: `Banff Shore is one of many pictures created during lockdown.<br><br>It depicts items such as stones, twigs, metal or pottery shards scattered all over the Moray shoreline reflecting the history of its industries, arts and lifestyle. These items are evocative of society past and present and will eventually be shaped, by the power of the ocean, into sand.<br><br>Only the detritus of our modern age, such as plastics, will stubbornly remain to pollute our beautiful land and ocean life. We can only hope that in mankind’s few seconds in the cosmic timescale we will learn to evolve and call a halt to the destruction of our truly beautiful and magnificent planet. I hope that Banff Shore reflects my love for this Earth and its place in the universe.`,
        displayMesh: 'N',
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    // {
    //     paintingId:  `${PAINTING_ID_POST_FIX}`,
    //     videoId: null,
    //     videoURL: null,
    //     // isMediaUsed: 'N',
    //     // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: ``,
    // },
    {
        paintingId:  `W09P31${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P31.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>This Woman's Place</h5>`,
        bodyText: `This was inspired by the local landscape of the Hermitage of Braid Nature Reserve in winter's snow. I walk here often and every time I see something new. It's an incredibly valuable local resource for our community: cyclists, walkers, dog-owners and climbers.  During 2020, it became a precious space for local residents. I want to see a future Scotland that protects these pockets of green space within our city boundaries.  Not only do they support a variety of fauna and flora, but they provide an accessible way for us all to re-connect with nature.  The landscape may not be as majestic as the Highlands, but it is no less important.  These everyday green spaces, where city children learn to identify wildflowers and birds, keep us grounded and aware of our environment.`,
        displayMesh: 'N',
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W09P32${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P32.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Holyrood</h5>`,
        bodyText: `This painting was made in Holyrood Park, winter 2021.  I am new to Scotland, when we were told not to leave the boundaries of Edinburgh during lockdown, I was struck by how much outdoor space Edinburgh has. I often rode my bike to the Pentlands, photographing and drawing the beauty I found there. On days where I didn't have as much time, I would run around Holyrood Park.  It is amazing this park and all its natural beauty is available in the middle of the city.  The preservation of green space is essential for our future.`,
        displayMesh: 'N',
        // annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 09 */

    /* Wall 10 */
    {
        paintingId:  `W10P33${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W10P33.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Fey</h5>`,
        bodyText: `This is Fey, my homage to Scottish Modernist writer and poet, Nan Shepherd.<br><br>Feyness is the iridescent exhilaration that comes over climbers, making them appear in Shepherd's words <i>"a little mad in the eyes of those who do not climb"</i>.  The design is inspired by my love of Nan’s writing and the mountain memoir <i>The Living Mountain</i>. As a keen hillwalker, her words are as essential as a map and compass. It is my hope that my artwork will guide more people to Shepherd and her writing, so they can see nature through her eyes. Perhaps then, they will care a little more for the very thing that sustains us all. However small the change, as Greta Thunberg proves, you are never too wee to make a difference.<br><br>The eye used in the design is my own. Fey also incorporates my landscape photography.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W10P34${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W10P34.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Immigrant Stones </h5>`,
        bodyText: `In this artwork, I use stones to visualize my idea of a more tolerant Scotland. Many stones found in Scotland came from what is now Norway and Sweden. They were brought here by a glacier during the Ice Age.  As the climate changed, the glacier melted, and the immigrant stones settled on Scottish soil. In my compositions, it is hard to see which stones are native and which are not; often they help one another maintain their balance.  Millions of people around the world are displaced due to global warming and the countries least responsible for climate change are the most vulnerable. We in Scotland must do what we can to help tackle the global climate crisis.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 10 */

    /* Wall 11 */
    {
        paintingId:  `W11P35${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}W11P35.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W11P35E01.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W11P35E02.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W11P35E03.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W11P35E04.jpg/info.json`
            , `${CANTALOUPE_IMAGE_SERVER}W11P35E05.jpg/info.json`],
        headerText: `<h5>Regeneration</h5>`,
        // bodyText: `<b>Close-up images of <i>'Regeneration'</i></b><br>This wall-hanging was inspired by the history of Scottish textile mills and other derelict industrial sites. From the left, the hand dyed and painted fabrics progress in colour from the dark homes and mills to shiny metal machinery that is then rusting decay. The vertical felted inserts represent cogs, an iconic industrial image, sharp shapes but eventually becoming soft humps, returning their minerals back to the ground. I am intrigued by sites such as these, the way nature and wildlife return to regenerate and soften the area. It is a joy to see the flowers grow tall and wildlife flourish, when given a chance.`,
        bodyText: `<b>Above, close-up images of <i>'Regeneration'</i></b><br><br>This wall-hanging was inspired by the history of Scottish textile mills and other derelict industrial sites. From the left, the hand dyed and painted fabrics progress in colour from the dark homes and mills to shiny metal machinery that is then rusting decay. The vertical felted inserts represent cogs, an iconic industrial image, sharp shapes but eventually becoming soft humps, returning their minerals back to the ground. I am intrigued by sites such as these, the way nature and wildlife return to regenerate and soften the area. It is a joy to see the flowers grow tall and wildlife flourish, when given a chance.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W11P36${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}W11P36.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}W11P36E01.jpg/info.json`],
        headerText: `<h5>Link by Link</h5>`,
        bodyText: `This sculpture symbolises the power of nature's ability to adapt and survive. Inspired by Scotland’s creeping leafy mosses, this tiny plant is growing abundantly along the chain against all the odds, reclaiming it as new habitat.  An ancient rootless plant, humble mosses have survived extreme climate changes and help re-establish new ecosystems in often uninhabitable locations. They play an important frequently overlooked role in biodiversity. The moss in this artwork shows a strong, realistic and hopeful future for Scotland’s nature. Our past choices and future actions have an undeniable chain reaction effect on the natural world. Link by Link acts as a reminder of the fragile balance within which we all live and the importance of protecting and conserving Scotland’s flora and fauna to ensure a better future.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W11T37${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Harnessing the Kelpie</h5>`,
        // bodyText: `The old mill is derelict, locked up,<br>shuttered,<br>and from the broken gutter, a single rain drop<br>leaks<br>and lands<br>on the spike of a thistle.<br>Moss coats the sullen water wheel, while<br>down in the hollow, the black- backed burn<br>snarls<br>like an angry kelpie.<br>Don’t you remember?<br>Don’t you remember when death hovered in the gap<br>between the millstones? When survival depended<br>on the turn of a wheel?<br>The water of life, indeed.<br>The power to grind,<br>the power to eat,<br>the power to feed.<br>A single splash of rain lands on the spike of a thistle.<br>Within it,<br>I can see the whole of Scotland;<br>a microcosm in a tear drop.<br>We have always had the power.<br>Time to harness the kelpie.<br><br>I am a National Trust for Scotland volunteer at Barry Mill, in Angus. This is an old watermill which, until the 1980s, ground corn for the entire community. Once, there were as many watermills in Scotland as there are now supermarkets. I cannot help but contrast the carbon footprint of my local supermarket, with its enormous electricity usage and inflated food miles, to the quiet, constant revolution of the water wheel, generating power from a free, natural, abundant resource.<br><br>My poem is a plea for us to use our natural, sustainable resources for our energy needs. Sometimes, the old ways can be made new! Traditionally, every watermill was guarded by its own water kelpie, which protected the families who used the mill from fairies and other malevolent creatures.`,
        bodyText: `The old mill is derelict, locked up,<br>shuttered,<br>and from the broken gutter, a single rain drop<br>leaks<br>and lands<br>on the spike of a thistle.<br>Moss coats the sullen water wheel, while<br>down in the hollow, the black- backed burn<br>snarls<br>like an angry kelpie.<br>Don’t you remember?<br>Don’t you remember when death hovered in the gap<br>between the millstones? When survival depended<br>on the turn of a wheel?<br>The water of life, indeed.<br>The power to grind,<br>the power to eat,<br>the power to feed.<br>A single splash of rain lands on the spike of a thistle.<br>Within it,<br>I can see the whole of Scotland;<br>a microcosm in a tear drop.<br>We have always had the power.<br>Time to harness the kelpie.<br><br><b>About the poem</b><br><br>I am a National Trust for Scotland volunteer at Barry Mill, in Angus. This is an old watermill which, until the 1980s, ground corn for the entire community. Once, there were as many watermills in Scotland as there are now supermarkets. I cannot help but contrast the carbon footprint of my local supermarket, with its enormous electricity usage and inflated food miles, to the quiet, constant revolution of the water wheel, generating power from a free, natural, abundant resource.<br><br>My poem is a plea for us to use our natural, sustainable resources for our energy needs. Sometimes, the old ways can be made new! Traditionally, every watermill was guarded by its own water kelpie, which protected the families who used the mill from fairies and other malevolent creatures.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W11P38${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W11P38.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Good Morning </h5>`,
        bodyText: `My collage was inspired by my dad coming home from a night shift and telling me about the beautiful morning skies. I mixed different shapes and colours that I thought worked well together into one shared space. I would love a future Scotland to do the same; work together to preserve all the treasures that make us a nation. It is how nature works at its best, and it is how we should too.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W11P39${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W11P39.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>In The Rain</h5>`,
        bodyText: `Nature has a wonderful ability to repair itself: replenishing and regenerating. We should be making this easier by taking our rubbish home and leaving areas how we found them - creating safe and peaceful habitats for our plants and animals. We are appreciating nature, the scenery of Scotland and the ever-changing weather, now more than ever. We are known for our dreich weather; however, rain has such great properties for not only our native species but also, the air. This piece aims to portray a stormy, Scottish scene with the rain lashing down and no litter in sight.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W11T40${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Grow a Pear</h5>`,
        // bodyText: `transport<br><br>why<br>the car pollution<br>why not<br>the chip fat solution<br><br>garden<br><br>why<br>leave the garden bare<br>why not<br>grow an apple, or a pear<br><br>why<br>plant ornamental trees<br>why not<br>cherries, berries, fruit and veggies<br><br>home<br><br>why<br>switch on the central heating<br>why not<br>toddy drinking, pandrop eating<br><br>why<br>turn up the thermostat<br>why not<br>put on a coat and hat<br><br>why<br>wood smoke and coal fumes<br>why not<br>insulate the attic and rooms<br><br>animals<br><br>why<br>wear Inuit sporrans made from seals<br>why not<br>dress down a bit for jigs and reels<br><br>why<br>shoot rabbits, grouse, geese, and pheasant<br>why not<br>substitute habits more peaceful, and pleasant<br><br>why<br>animals, birds, and fishes<br>why not<br>vegan and vegetarian dishes<br><br>environment<br><br>why<br>drink from a styrofoam cup at ceilidhs<br>why not<br>bring your own to the wailidh wailidhs<br><br>why<br>walk away from the dog’s aftermath<br>why not<br>flick it with a stick off the woodland path<br><br>why<br>the rat race, the big spend<br>why not<br>make do and mend<br><br>why<br>the upgrade, the new phoneses<br>why not<br>be unswayed by the Joneses<br><br>why<br>treat Scotland like a tip<br>why not<br>take pride in custodianship`,
        bodyText: `<b>Transport</b><br><br>Why<br>the car pollution<br>why not<br>the chip fat solution<br><br><b>garden</b><br><br>why<br>leave the garden bare<br>why not<br>grow an apple, or a pear<br><br>why<br>plant ornamental trees<br>why not<br>cherries, berries, fruit and veggies<br><br><b>home</b><br><br>why<br>switch on the central heating<br>why not<br>toddy drinking, pandrop eating<br><br>why<br>turn up the thermostat<br>why not<br>put on a coat and hat<br><br>why<br>wood smoke and coal fumes<br>why not<br>insulate the attic and rooms<br><br><b>animals</b><br><br>why<br>animals, birds, and fishes<br>why not<br>vegan and vegetarian dishes<br><br><b>environment</b><br><br>why<br>drink from a styrofoam cup at ceilidhs<br>why not<br>bring your own to the wailidh wailidhs<br><br>why<br>walk away from the dog’s aftermath<br>why not<br>flick it with a stick off the woodland path<br><br>why<br>the rat race, the big spend<br>why not<br>make do and mend<br><br>why<br>the upgrade, the new phoneses<br>why not<br>be unswayed by the Joneses<br><br>why<br>treat Scotland like a tip<br>why not<br>take pride in custodianship`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W11P41${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W11P41.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h6>Green energy powering the nation for a sustainable future</h6>`,
        bodyText: `My vision of a future Scotland is a green and pleasant land powered entirely by renewable energy; this will ensure that the environment is preserved for generations to come.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W11P42${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W11P42.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Seasonal and home-grown food</h5>`,
        bodyText: `As an amateur artist, I take my inspiration from nature and studying the work of other artists. My painting is a vision of the future where most of our food is seasonal and home-grown. I believe we are becoming increasingly separated from where and how our food is produced; in particular, transporting food around the world is increasingly hard to justify. To eat more sustainably and cut our carbon footprint we need to move to more local mixed-farming systems, thereby boosting the health of our planet as well as ourselves.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 11 */

    /* Wall 12 */
    {
        paintingId:  `W12P43${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W12P43.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>By Aurora Light </h5>`,
        bodyText: `My greatest hope for the future is for there to be more hedgerows and wild spaces in nature. In areas which are being developed, I would like to see businesses and companies encourage the planting and renewal of green and wild spaces, not the removal of them. I have witnessed the Aurora Borealis many times living in Scotland and use this as a metaphor for hope and dramatic impact in many of my paintings. In this painting the wilds are flowering under the magical light of the aurora. This is my hope for the future of the wilds in Scotland.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W12T44${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>A Grandmother's Hope for the Hebrides</h5>`,
        // bodyText: `My little ones, when you are fully grown,<br>may there still be pristine beaches.<br>May Hebridean seas delight you<br>with iridescent blue-green colours,<br>changing constantly with light.<br><br>May you know the places where<br>the seals bask on low tide rocks,<br>and listen to their song.<br>And as you walk along, may<br>some swim up and take a look at you.<br><br>I hope the seas are full<br>of dolphins leaping<br>swiftly over the waves,<br>making your heart leap too<br>with joy at the sight of them.<br><br>Let there be otters rolling<br>playfully in liquid heaven,<br>or taking a morning swim<br>in quiet rocky bays,<br>looking for breakfast.<br><br>May clouds of puffins be<br>whirring overhead on Mingulay<br>to find their burrows. And sheer<br>cliff edges teem with<br>noisy sea bird life.<br><br>Let gannets plunge and dive<br>like stream-lined missiles<br>into the sea. May they make<br>you breathless with<br>their speed and skill.<br><br>And may you thrill<br>to see an eagle soar<br>high above the hill,<br>where lapwings sing<br>their plaintive call.<br><br>Ah may you know all this.<br>Treasure, and protect it all.<br><br>I was born in England but have lived in Scotland for 49 years. I am a wife, mother and grandmother. I love the Scottish scenery and wildlife. I have a particular love for the Hebrides where I have enjoyed many inspiring holidays with my children when they were young, and with my husband in our retirement. This poem arose out of my concern that we care for the Earth, the wildlife and these special places so other generations may benefit and enjoy them. The poem speaks of my hope that my two little granddaughters, aged 4 years and 20 months, will be able to know, appreciate and care for these wild places.`,
        bodyText: `My little ones, when you are fully grown,<br>may there still be pristine beaches.<br>May Hebridean seas delight you<br>with iridescent blue-green colours,<br>changing constantly with light.<br><br>May you know the places where<br>the seals bask on low tide rocks,<br>and listen to their song.<br>And as you walk along, may<br>some swim up and take a look at you.<br><br>I hope the seas are full<br>of dolphins leaping<br>swiftly over the waves,<br>making your heart leap too<br>with joy at the sight of them.<br><br>Let there be otters rolling<br>playfully in liquid heaven,<br>or taking a morning swim<br>in quiet rocky bays,<br>looking for breakfast.<br><br>May clouds of puffins be<br>whirring overhead on Mingulay<br>to find their burrows. And sheer<br>cliff edges teem with<br>noisy sea bird life.<br><br>Let gannets plunge and dive<br>like stream-lined missiles<br>into the sea. May they make<br>you breathless with<br>their speed and skill.<br><br>And may you thrill<br>to see an eagle soar<br>high above the hill,<br>where lapwings sing<br>their plaintive call.<br><br>Ah may you know all this.<br>Treasure, and protect it all.<br><br><b>About the poem</b><br><br>I was born in England but have lived in Scotland for 49 years. I am a wife, mother and grandmother. I love the Scottish scenery and wildlife. I have a particular love for the Hebrides where I have enjoyed many inspiring holidays with my children when they were young, and with my husband in our retirement. This poem arose out of my concern that we care for the Earth, the wildlife and these special places so other generations may benefit and enjoy them. The poem speaks of my hope that my two little granddaughters, aged 4 years and 20 months, will be able to know, appreciate and care for these wild places.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 12 */

    /* Wall 13 */
    {
        paintingId:  `W13T45${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>The Fight of the Wyld Cattis</h5>`,
        // bodyText: `We arrived after the Ice Age, when pine was dense, seeking the shallows of lochs to wash scent from our paws. Solitary shadows that stalked north in the moonlight. We dined on moles and mountain hare, chased rodents that squeaked.<br><br>To become a totem for Picts. Slain so our pelts could adorn their skin. A symbol of bravery, of their combative spirit.<br><br>Still, we roamed.<br><br>Centuries spun on, when spears became swords, as clan fought clan and our heads became prized - for their sporrans. Our clawed feet brushed and mounted as fluffy tassels.<br><br>Not satisfied with severing our body, they claimed our nature too. Our agility, our strength. Our image fixed in family crests.<br><br>Then the gentry took to sport, and gamekeepers sought ‘beasts for the chase’, setting hounds upon us. But we stood our ground, teeth bared, as dogs howled and men with shotguns inched near. Until stories around the fireside grew, of our ferocity, our savagery.<br><br>So, they trapped us. Like vermin. Us! Once revered by the ancients; worshipped by the Cait people of Caithness.<br><br>Us! A cat who climbs trees. A cat who can swim, between mainland and isle. Across lochans when we’ve a mind to escape.<br><br>At twilight we stealth, belly low, grass and litter leaf beneath our feet. We stare. We wait. One lightning flick of a paw, a sharp bite to the back of the neck, and we eat.<br><br>Wind ripples my fur, as I prowl ancient woodland. My ears prick. A swoosh of wings. An eagle dives at my young. I growl, spit... pounce. I hook my claws into its chest, kicking and tearing at feathers as it rises, until innards fly free. Bloodied, we plummet…<br><br>Deer roar. A capercaillie clucks as kits tumble around the cairn. Their eyes blink, pale blue. I curl my bushy tail about me.<br><br>When food is plentiful and the sun warm, I bask on rocky outcrops.<br><br>I seek a quiet life. A den, to rear my kittens without fear.<br><br>But we are endangered. Our numbers perilously low. My family may not survive. The warriors we have been, the place we’ve earned in history, is not enough.<br><br>Battle-scarred, we need your help.<br><br>We know you can fight.<br><br>Yours,<br>A Wildcat<br><br>As soon as I learned of the Great Scottish Canvas, I knew I wished to write about the Highland wildcat. Such a majestic animal, one Scotland must do everything in its power to protect. Then during research, when I discovered how symbolic the wildcat was for both the Picts and Highland clans, I knew my piece must revolve around the battles the animal endured in the past, but, more importantly, the fight it now faces to survive. The only way I could tell that tale was through the eyes of a wildcat.`,
        bodyText: `We arrived after the Ice Age, when pine was dense, seeking the shallows of lochs to wash scent from our paws. Solitary shadows that stalked north in the moonlight. We dined on moles and mountain hare, chased rodents that squeaked.<br><br>To become a totem for Picts. Slain so our pelts could adorn their skin. A symbol of bravery, of their combative spirit.<br><br>Still, we roamed.<br><br>Centuries spun on, when spears became swords, as clan fought clan and our heads became prized - for their sporrans. Our clawed feet brushed and mounted as fluffy tassels.<br><br>Not satisfied with severing our body, they claimed our nature too. Our agility, our strength. Our image fixed in family crests.<br><br>Then the gentry took to sport, and gamekeepers sought ‘beasts for the chase’, setting hounds upon us. But we stood our ground, teeth bared, as dogs howled and men with shotguns inched near. Until stories around the fireside grew, of our ferocity, our savagery.<br><br>So, they trapped us. Like vermin. Us! Once revered by the ancients; worshipped by the Cait people of Caithness.<br><br>Us! A cat who climbs trees. A cat who can swim, between mainland and isle. Across lochans when we’ve a mind to escape.<br><br>At twilight we stealth, belly low, grass and litter leaf beneath our feet. We stare. We wait. One lightning flick of a paw, a sharp bite to the back of the neck, and we eat.<br><br>Wind ripples my fur, as I prowl ancient woodland. My ears prick. A swoosh of wings. An eagle dives at my young. I growl, spit... pounce. I hook my claws into its chest, kicking and tearing at feathers as it rises, until innards fly free. Bloodied, we plummet…<br><br>Deer roar. A capercaillie clucks as kits tumble around the cairn. Their eyes blink, pale blue. I curl my bushy tail about me.<br><br>When food is plentiful and the sun warm, I bask on rocky outcrops.<br><br>I seek a quiet life. A den, to rear my kittens without fear.<br><br>But we are endangered. Our numbers perilously low. My family may not survive. The warriors we have been, the place we’ve earned in history, is not enough.<br><br>Battle-scarred, we need your help.<br><br>We know you can fight.<br><br>Yours,<br>A Wildcat<br><br><b>About the poem</b><br><br>As soon as I learned of the Great Scottish Canvas, I knew I wished to write about the Highland wildcat. Such a majestic animal, one Scotland must do everything in its power to protect. Then during research, when I discovered how symbolic the wildcat was for both the Picts and Highland clans, I knew my piece must revolve around the battles the animal endured in the past, but, more importantly, the fight it now faces to survive. The only way I could tell that tale was through the eyes of a wildcat.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W13T46${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>The World I Want</h5>`,
        // bodyText: `I want for Scotland what I want for all<br>the world that congregates in Glasgow soon,<br>I want commitment, promises fulfilled,<br>no hint of COP-out 26.<br><br>I want to wake and breath in air that’s clean,<br>hear news of oceans cooler, reefs revived;<br>I want proper recycling, no more litter<br>by the roads, and fewer cars.<br><br>I want to listen to the sound of bees,<br>strike out the use of harmful pesticides;<br>I want to ban rare metal batteries,<br>and change the way we think of fuel.<br><br>I want the poor to drink in safer places<br>water from an unpolluted well;<br>I want to cut the felling of the forests,<br>nurse these frayed and fragile lungs.<br><br>I want the can-do spirit of Prince Philip,<br>with the nous of David Attenborough<br>and the voice of youth like Greta Thunberg<br>sounding in our public ears.<br><br>I want the rich to practise carbon pricing,<br>turn their economics right way up;<br>I want a government that hears my voice<br>no less, no more than any other.<br><br>I want to put some money where my mouth is,<br>pay for stuff that’s ethically sourced;<br>I want to buy more eco-friendly products,<br> pull my weight, reduce my footprint.<br><br>I want the human species to be modest<br>stewards of our home on planet earth;<br>I want respect for every form of life,<br>and start by saying, ‘Yes we can!’<br><br>Someone said that the world is run by middle-aged people who are invested in maintaining the world as they know it. When we are young, we have ideas and imagine all kinds of possibilities, and then we look for a job and so on and become immersed in the world as it is. Now that I am in my 80th year, I am growing younger again, and want to see the world as it ought to be.`,
        bodyText: `I want for Scotland what I want for all<br>the world that congregates in Glasgow soon,<br>I want commitment, promises fulfilled,<br>no hint of COP-out 26.<br><br>I want to wake and breath in air that’s clean,<br>hear news of oceans cooler, reefs revived;<br>I want proper recycling, no more litter<br>by the roads, and fewer cars.<br><br>I want to listen to the sound of bees,<br>strike out the use of harmful pesticides;<br>I want to ban rare metal batteries,<br>and change the way we think of fuel.<br><br>I want the poor to drink in safer places<br>water from an unpolluted well;<br>I want to cut the felling of the forests,<br>nurse these frayed and fragile lungs.<br><br>I want the can-do spirit of Prince Philip,<br>with the nous of David Attenborough<br>and the voice of youth like Greta Thunberg<br>sounding in our public ears.<br><br>I want the rich to practise carbon pricing,<br>turn their economics right way up;<br>I want a government that hears my voice<br>no less, no more than any other.<br><br>I want to put some money where my mouth is,<br>pay for stuff that’s ethically sourced;<br>I want to buy more eco-friendly products,<br> pull my weight, reduce my footprint.<br><br>I want the human species to be modest<br>stewards of our home on planet earth;<br>I want respect for every form of life,<br>and start by saying, ‘Yes we can!’<br><br><b>About the poem</b><br><br>Someone said that the world is run by middle-aged people who are invested in maintaining the world as they know it. When we are young, we have ideas and imagine all kinds of possibilities, and then we look for a job and so on and become immersed in the world as it is. Now that I am in my 80th year, I am growing younger again, and want to see the world as it ought to be.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W13P47${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W13P47.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>I stand up for what I stand on</h5>`,
        bodyText: `THA MISE A’ SEASAMH<br>SUAS AIRSON NA THA MI<br>A’<br>SEASAMH<br>AIR!`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W13T48${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W13T48E01.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Extinction Rebellion</h5>`,
        // bodyText: `<b>Illustration by Les McConnell</b><br>I fauldit a wittin<br>In a tuim plastic bottle<br>And flung it faur out in the weet.<br><br>“Gin ye find this gae rescue<br>The hetteran Warld.”<br>The waves brocht it back tae ma feet.<br><br><b>Fauldit:</b> folded<br><b>Wittin:</b> message<br><b>Tuim:</b> empty<br><b>Faur:</b> far<br><b>Weet:</b> wet, the sea<br><b>Hetteran:</b> boiling<br><b>Brocht:</b> brought`,
        bodyText: `<b>Above, illustration by Les McConnell</b><br><br>I fauldit a wittin<br>In a tuim plastic bottle<br>And flung it faur out in the weet.<br><br>“Gin ye find this gae rescue<br>The hetteran Warld.”<br>The waves brocht it back tae ma feet.<br><br><b>Fauldit:</b> folded<br><b>Wittin:</b> message<br><b>Tuim:</b> empty<br><b>Faur:</b> far<br><b>Weet:</b> wet, the sea<br><b>Hetteran:</b> boiling<br><b>Brocht:</b> brought`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W13T49${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Clumlie Loch</h5>`,
        // bodyText: `A mean wind talks over them all.<br><br>Two bonxies* joust above<br>the loch - was it for<br>love or tug of<br>war?<br>Black headed gulls<br>laugh from<br>the side...<br>Trio of manes<br>just off<br>the<br>holm,<br>two<br>meadow pipits on<br>wire,<br>eager to court tucked in<br>heather;<br>invisible crooning<br>curlews as<br>line chorus fill a sky blue in<br>defiance to each outburst from<br>the prowler that heaves wavelets on the water.<br>Everything yields in its presence:<br><br>from the lichen stricken fence posts to<br>daffodils back from the dead,<br>hell, hellery*, blown at<br>Easter...<br>They,<br>like the<br>dwellers from<br>the loch, stood to<br>its wrath and raging claws;<br>yet skylarks hoist high into sky and<br>sing along in spring evening<br>cacophonous around<br>it all -<br>rain goose* elegance, scarlet throats,<br>sleek and silent as<br>spectators...<br>And<br>water hums<br>through the old sluice, iris and<br>burn* down to Troswick via<br>grinding stones,<br>forgotten<br>times,<br>Iain<br>fixes<br>voar efter voar. *<br><br>Glossary fae da Shetland dialect:<br>Bonxies: Great Skuas;<br>Hellery: adverse weather (heavy precipitation falling diagonally / horizontally due to gales);<br>Rain goose: Red-Throated Diver / Loon;<br>Burn: a stream;<br>Voar efter voar: Spring after spring (season)<br><br>I am a poet fae Shetland, whose work is mainly inspired from nature in my archipelago. This poem is about Clumlie Loch at spring, celebrating the teeming wildlife and place. Tis one of the last corners of semi-wilderness in the South Mainland of Shetland, Scotland where we, humans, can still watch wildlife, nature, as it happens on Earth.`,
        bodyText: `A mean wind talks over them all.<br><br>Two bonxies* joust above<br>the loch - was it for<br>love or tug of<br>war?<br>Black headed gulls<br>laugh from<br>the side...<br>Trio of manes<br>just off<br>the<br>holm,<br>two<br>meadow pipits on<br>wire,<br>eager to court tucked in<br>heather;<br>invisible crooning<br>curlews as<br>line chorus fill a sky blue in<br>defiance to each outburst from<br>the prowler that heaves wavelets on the water.<br>Everything yields in its presence:<br><br>from the lichen stricken fence posts to<br>daffodils back from the dead,<br>hell, hellery*, blown at<br>Easter...<br>They,<br>like the<br>dwellers from<br>the loch, stood to<br>its wrath and raging claws;<br>yet skylarks hoist high into sky and<br>sing along in spring evening<br>cacophonous around<br>it all -<br>rain goose* elegance, scarlet throats,<br>sleek and silent as<br>spectators...<br>And<br>water hums<br>through the old sluice, iris and<br>burn* down to Troswick via<br>grinding stones,<br>forgotten<br>times,<br>Iain<br>fixes<br>voar efter voar. *<br><br>Glossary fae da Shetland dialect:<br>Bonxies: Great Skuas;<br>Hellery: adverse weather (heavy precipitation falling diagonally / horizontally due to gales);<br>Rain goose: Red-Throated Diver / Loon;<br>Burn: a stream;<br>Voar efter voar: Spring after spring (season)<br><br><b>About the poem</b><br><br>I am a poet fae Shetland, whose work is mainly inspired from nature in my archipelago. This poem is about Clumlie Loch at spring, celebrating the teeming wildlife and place. Tis one of the last corners of semi-wilderness in the South Mainland of Shetland, Scotland where we, humans, can still watch wildlife, nature, as it happens on Earth.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 13 */

    /* Wall 14 */
    {
        paintingId:  `W14T50${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Batter on</h5>`,
        // bodyText: `On Seeing Snowdrops on Pancake Day<br><br>This bunch is more green than white<br>the seed is merged with its mother stem<br>a bud appears.<br><br>In this clump the pods are open,<br>leaves unfurl, spears protrude, some will<br>become warriors,<br><br>while others will keep their frilly knickers<br>primly tucked up beneath, just as<br>Ma told them to.<br><br>Despite the loads of snow poured on top,<br>you have grown tall and proud<br>little gallants.<br><br>These white beginnings will give way<br>to royal pavings of violets in the forest<br>and bluebells will call<br>to clear skies <br><br>till the snows come again<br>and you are summoned to<br>mount the stage another time, to<br>batter on.<br><br>If every person in Scotland adopted a local green space and loved it and protected it, our cities would breathe. I live in a city and there are Friends of the local parks and even Friends of the Cemetery. We post photos online of birds, trees and flowers. We watch the unfolding of the seasons in their still natural rhythm.<br><br>The first flowers of spring, snowdrops, begin to appear in February, around Pancake Day. This year, I bent down to have a good look and the leaves reminded me of spears. We have to fight for green spaces. They are always under threat. Although the future does not always look rosy, if we want it to be green, we have to keep trying.`,
        bodyText: `On Seeing Snowdrops on Pancake Day<br><br>This bunch is more green than white<br>the seed is merged with its mother stem<br>a bud appears.<br><br>In this clump the pods are open,<br>leaves unfurl, spears protrude, some will<br>become warriors,<br><br>while others will keep their frilly knickers<br>primly tucked up beneath, just as<br>Ma told them to.<br><br>Despite the loads of snow poured on top,<br>you have grown tall and proud<br>little gallants.<br><br>These white beginnings will give way<br>to royal pavings of violets in the forest<br>and bluebells will call<br>to clear skies <br><br>till the snows come again<br>and you are summoned to<br>mount the stage another time, to<br>batter on.<br><br><b>About the poem</b><br><br>If every person in Scotland adopted a local green space and loved it and protected it, our cities would breathe. I live in a city and there are Friends of the local parks and even Friends of the Cemetery. We post photos online of birds, trees and flowers. We watch the unfolding of the seasons in their still natural rhythm.<br><br>The first flowers of spring, snowdrops, begin to appear in February, around Pancake Day. This year, I bent down to have a good look and the leaves reminded me of spears. We have to fight for green spaces. They are always under threat. Although the future does not always look rosy, if we want it to be green, we have to keep trying.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W14T51${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Everything depends on us</h5>`,
        // bodyText: `The weather in future is important.<br>Seas without plastic, people each day who care<br>sowing flowers in every cement back court<br>to bring happiness and colour. Can you drink one less juice each day?<br>Bottles lie everywhere. The protection of rivers and the sky<br>will make this place colourful and bright.<br>It is very clear. We need education<br>for the practical, we need walls made of trees.<br>We will not cut down a tree to make a house<br>we will build the house around the tree.<br><br>Less concrete<br>more gardens. Each of us plant a tree<br>to create this new space. People<br>will take responsibility for their actions. We can take<br>from the past, swapping things, growing things. Rainwater harvesting.<br>Two walkways along each side of the river. Plenty<br>of space for us all in this beautiful city. Collect the rain<br>for the beauty of the garden. A path for our bikes,<br>no plastic cups, houses which blossom. Spare spaces can flourish,<br>walls send messages<br>of respect. Care exists. We and the animals exist.<br>What we give is what we get back in return.<br><br>Everything depends on us was collectively written by Maryhill Integration Network's creative writing group for the Great Scottish Canvas. The group is made up of refugee, asylum seeking, migrant and local writers who have been meeting online to talk and write together. This poem expresses the hopes and desires the members of the group have for the future of Scotland's nature, from an urban perspective.`,
        bodyText: `The weather in future is important.<br>Seas without plastic, people each day who care<br>sowing flowers in every cement back court<br>to bring happiness and colour. Can you drink one less juice each day?<br>Bottles lie everywhere. The protection of rivers and the sky<br>will make this place colourful and bright.<br>It is very clear. We need education<br>for the practical, we need walls made of trees.<br>We will not cut down a tree to make a house<br>we will build the house around the tree.<br><br>Less concrete<br>more gardens. Each of us plant a tree<br>to create this new space. People<br>will take responsibility for their actions. We can take<br>from the past, swapping things, growing things. Rainwater harvesting.<br>Two walkways along each side of the river. Plenty<br>of space for us all in this beautiful city. Collect the rain<br>for the beauty of the garden. A path for our bikes,<br>no plastic cups, houses which blossom. Spare spaces can flourish,<br>walls send messages<br>of respect. Care exists. We and the animals exist.<br>What we give is what we get back in return.<br><br><b>About the poem</b><br><br><i>Everything depends on us</i> was collectively written by Maryhill Integration Network's creative writing group for the Great Scottish Canvas. The group is made up of refugee, asylum seeking, migrant and local writers who have been meeting online to talk and write together. This poem expresses the hopes and desires the members of the group have for the future of Scotland's nature, from an urban perspective.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W14T52${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Pollution</h5>`,
        bodyText: `Listen children and adults, we are under risk of pollution.<br>Pollution is a poisonous smoke, we must think about it.<br><br>Consider something, be wise and be prepare for it.<br>This is not a big thing, do not think and say that I can’t do it.<br><br>If you love humanity, start to play your role right now.<br>If you go to work at same place share care and use the Train<br>and bus more frequently.<br><br>If you go a short distance, you can walk.<br>If your school is close, you can use a bike.<br><br>If you want to have a bath, have a shower instead.<br>Cut the use of plastic and make it zero.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W14T53${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Scotland 2030</h5>`,
        // bodyText: `Pause and listen to air fresh with birdsong<br>People flock to hear.<br><br>Defence disbanded in trust of peace,<br>we hold out our hands.<br>We use our funds to build and<br>nourish,<br>not destroy<br><br>Trident moves to memory,<br>leaving turbines to tick in the tidal ebb and flow<br>and sun to glint off panelled roofs and verdant living walls.<br>Bringing our homes clean light and warmth,<br>and life.<br><br>We grow our forests, reaching across canopies to entwine our stories with<br>those of bugs, and birds and deer.<br>The peatbogs of our ancestors soak carbon from the leaden skies,<br>so too the seagrass beds, slurping carbon from the briny waves<br>Marine reserves and fish are managed well,<br>for plate and future.<br><br>We ride, we walk, take buses, trains and trams,<br>hither and thither across our land at will.<br>We have no need for cars.<br>Flying rarely and thoughtfully, we taste the world’s variety,<br>returning home to share the joy and inspiration and to pause<br>To listen to air fresh with birdsong<br>People flock to hear.<br><br>I wrote this poem hoping to capture a little of the future I want to see for Scotland. I love Costa Rica's approach where money saved by disbanding the military in favour of peace has ensured that funds have been available for reforesting and engaging with ecotourism and celebrating the country's natural gifts. Here, we have such an opportunity for renewable energy, peatland restoration and ocean recovery that we now just need to grasp the potential and run with it.`,
        bodyText: `Pause and listen to air fresh with birdsong<br>People flock to hear.<br><br>Defence disbanded in trust of peace,<br>we hold out our hands.<br>We use our funds to build and<br>nourish,<br>not destroy<br><br>Trident moves to memory,<br>leaving turbines to tick in the tidal ebb and flow<br>and sun to glint off panelled roofs and verdant living walls.<br>Bringing our homes clean light and warmth,<br>and life.<br><br>We grow our forests, reaching across canopies to entwine our stories with<br>those of bugs, and birds and deer.<br>The peatbogs of our ancestors soak carbon from the leaden skies,<br>so too the seagrass beds, slurping carbon from the briny waves<br>Marine reserves and fish are managed well,<br>for plate and future.<br><br>We ride, we walk, take buses, trains and trams,<br>hither and thither across our land at will.<br>We have no need for cars.<br>Flying rarely and thoughtfully, we taste the world’s variety,<br>returning home to share the joy and inspiration and to pause<br>To listen to air fresh with birdsong<br>People flock to hear.<br><br><b>About the poem</b><br><br>I wrote this poem hoping to capture a little of the future I want to see for Scotland. I love Costa Rica's approach where money saved by disbanding the military in favour of peace has ensured that funds have been available for reforesting and engaging with ecotourism and celebrating the country's natural gifts. Here, we have such an opportunity for renewable energy, peatland restoration and ocean recovery that we now just need to grasp the potential and run with it.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W14T54${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14T54E01.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>From Gran</h5>`,
        // bodyText: `I’d like to see the next generation<br>viewing Scotland through WWF eyes<br>Inspire my grandchildren to think<br>Teach them to protect our planet<br>Tell them if we’re on the brink<br>Of losing bird, plant or beast<br>Get them to look at the sky and sea<br>Let pupils cycle or walk<br>Make nature their natural home<br>Help each child to draw and talk<br>Show them the martins high<br>Warbling wrens down low<br>See harebells, gorse and vetch<br>Open their eyes to restoration<br>And spot the plastic in the ditch.<br><br>Let each child be a sentinel<br>Aware of melting ice caps<br>Our weather’s unpredictability<br>Floods, drought, fire, quakes<br>Make them aware of possibility<br>The changes we all must make<br>Our next generation should know<br>It's how we live that taints<br>The nature they’ll inherit<br>Show there must be constraints<br>On Grannie’s plastic generation<br>Which must quickly cease<br>Get schools to restore, rethink<br>Grandchildren please amend<br>Gran’s paper trail must end.<br><br>I wrote this poem for my 7-year-old grandson Ryan. Recently he asked his mum if he and his best friend could go to their wee park to 'pick up litter'. Everyone was amazed because he wouldn't take no for an answer and nagged till the rubber gloves came out and an empty plastic bag. Off they went and collected a full large bag of litter. I try to encourage children to look at the natural world around them because I did this when I was young. My dad taught me to recognise birds, and I'd like Ryan to be the same. It's never just a walk, it's a search and listen too.`,
        bodyText: `<b>Above, handwritten version of <i>‘From Gran’</i></b><br><br>I’d like to see the next generation<br>viewing Scotland through WWF eyes<br>Inspire my grandchildren to think<br>Teach them to protect our planet<br>Tell them if we’re on the brink<br>Of losing bird, plant or beast<br>Get them to look at the sky and sea<br>Let pupils cycle or walk<br>Make nature their natural home<br>Help each child to draw and talk<br>Show them the martins high<br>Warbling wrens down low<br>See harebells, gorse and vetch<br>Open their eyes to restoration<br>And spot the plastic in the ditch.<br><br>Let each child be a sentinel<br>Aware of melting ice caps<br>Our weather’s unpredictability<br>Floods, drought, fire, quakes<br>Make them aware of possibility<br>The changes we all must make<br>Our next generation should know<br>It's how we live that taints<br>The nature they’ll inherit<br>Show there must be constraints<br>On Grannie’s plastic generation<br>Which must quickly cease<br>Get schools to restore, rethink<br>Grandchildren please amend<br>Gran’s paper trail must end.<br><br><b>About the poem</b><br><br>I wrote this poem for my 7-year-old grandson Ryan. Recently he asked his mum if he and his best friend could go to their wee park to 'pick up litter'. Everyone was amazed because he wouldn't take no for an answer and nagged till the rubber gloves came out and an empty plastic bag. Off they went and collected a full large bag of litter. I try to encourage children to look at the natural world around them because I did this when I was young. My dad taught me to recognise birds, and I'd like Ryan to be the same. It's never just a walk, it's a search and listen too.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    {
        paintingId:  `W14T55${PAINTING_ID_POST_FIX}`,
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
        headerText: `<h5>Bawd bi the dee</h5>`,
        // bodyText: `There's a bawd in the park aside the Dee,<br>Far the Tulloch wids hing broon,<br>Fin the birk trees shakk, his lugs preen back,<br>Gainst the win he's hunkered doon.<br><br>Tho my tales be telt, an my heirskip selt<br>The Dee is an on-gaun story<br>The bawd in the wid wi his fur hauf hid<br>An the beech in its copper glory<br><br>My fowk an their spikk hae fled like rikk,<br>Nane here noo share my bluid,<br>Yet this snaaflake airt ay claims my hairt<br>I am my faither's seed.<br><br>Fur an feather an hoof an horn<br>Are fashions that dinna change,<br>An the michty stag on the muckle crag,<br>Is tap o designer range.<br><br>Tho monarchs crummle an empires cowp,<br>Like wauchts o winnlestrae,<br>The flash o finn ower the tummlin linn<br>Will be there till the eyn o day.<br><br>Commuter chiels bi the Tulloch puils,<br>Will be stoor an aisse an smush,<br>Bit the troot, the erne, an the wyvin fern<br>Will be here wi the hurlygush.<br><br>Fin the ile rins oot, an the gushers sproot<br>On Galaxy X or Mars,<br>The bawd'll be bi the dimplin Dee<br>Wi his preen-prick friens, the stars.<br><br>The Bawd bi the Dee appeared in my pamphlet 'A Boorich o Breets’, published by Severin Books in 2002. I've always been aware of how fleeting mortal life is, compared with the Bens and Rivers of Deeside, and I foresee that when men as we know them have vanished from the planet, the Glens of the Cairngorms and their animals will survive.`,
        bodyText: `There's a bawd in the park aside the Dee,<br>Far the Tulloch wids hing broon,<br>Fin the birk trees shakk, his lugs preen back,<br>Gainst the win he's hunkered doon.<br><br>Tho my tales be telt, an my heirskip selt<br>The Dee is an on-gaun story<br>The bawd in the wid wi his fur hauf hid<br>An the beech in its copper glory<br><br>My fowk an their spikk hae fled like rikk,<br>Nane here noo share my bluid,<br>Yet this snaaflake airt ay claims my hairt<br>I am my faither's seed.<br><br>Fur an feather an hoof an horn<br>Are fashions that dinna change,<br>An the michty stag on the muckle crag,<br>Is tap o designer range.<br><br>Tho monarchs crummle an empires cowp,<br>Like wauchts o winnlestrae,<br>The flash o finn ower the tummlin linn<br>Will be there till the eyn o day.<br><br>Commuter chiels bi the Tulloch puils,<br>Will be stoor an aisse an smush,<br>Bit the troot, the erne, an the wyvin fern<br>Will be here wi the hurlygush.<br><br>Fin the ile rins oot, an the gushers sproot<br>On Galaxy X or Mars,<br>The bawd'll be bi the dimplin Dee<br>Wi his preen-prick friens, the stars.<br><br><b>About the poem</b><br><br>The <i>Bawd bi the Dee</i> appeared in my pamphlet 'A Boorich o Breets’, published by Severin Books in 2002. I've always been aware of how fleeting mortal life is, compared with the Bens and Rivers of Deeside, and I foresee that when men as we know them have vanished from the planet, the Glens of the Cairngorms and their animals will survive.`,
        displayMesh: 'N',
        annotation_location_horiz_offset: SPRITE_HORIZONTAL_OFFSET,
    },
    /* Wall 14 */
/* Image and Wall Text */

];

export {AnnotationsDB};
